"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceProperty = void 0;
function replaceProperty(subject, key, value) {
    return { ...subject, [key]: value };
}
exports.replaceProperty = replaceProperty;
//# sourceMappingURL=replaceProperty.js.map